import { render, staticRenderFns } from "./NotificationBrandingTemplateSetup.vue?vue&type=template&id=05a4ac2b&scoped=true"
import script from "./NotificationBrandingTemplateSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationBrandingTemplateSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationBrandingTemplateSetup.vue?vue&type=style&index=0&id=05a4ac2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a4ac2b",
  null
  
)

export default component.exports